import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Send, Loader2 } from 'lucide-react';

export const ChatInput = ({ onSend, loading }) => {
  const [text, setText] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!text.trim() || loading) return;
    onSend(text);
    setText('');
  };
  return (
    <form onSubmit={handleSubmit} className="flex gap-2 p-4 bg-white backdrop-blur-xl border-t border-[#E8E4DF] rounded-b-card">
      <Input placeholder="描述你的旅行需求，或补充修改意见..." value={text} onChange={(e) => setText(e.target.value)} className="flex-1 rounded-btn border-[#E8E4DF] bg-bg-secondary focus:bg-white text-text-primary placeholder:text-text-tertiary focus:border-primary focus:ring-primary/20" />
      <Button type="submit" disabled={loading} className="rounded-full bg-primary hover:bg-primary-hover text-white px-6 shadow-btn">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
      </Button>
    </form>
  );
};
